// TODO: Consolidate this file with circuit-shared's version, in design-system/utilities or another package
import {
  MgCannabis,
  MgCapsule,
  MgCartridge,
  MgDevice,
  MgInhaler,
  MgOralLiquid,
  MgPastille,
  MgPowder,
  MgResin,
  MgSpray,
  MgTablets,
  MgTopical,
  MgWafer
} from '@montugroup/icons';
import type { SvgIcon } from '@mui/material';

export const ProductFormulations = {
  ORAL_LIQUID: 'Oral Liquid',
  HERB_DRIED: 'Herb, Dried',
  CAPSULE: 'Capsule',
  PASTILLE: 'Pastille',
  DEVICE: 'Device',
  INHALATION: 'Inhalation',
  TOPICAL: 'Topical',
  SPRAY: 'Spray',
  WAFER: 'Wafer',
  TABLET_CHEWABLE: 'Tablet, Chewable',
  CONCENTRATED_EXTRACT: 'Concentrated Extract',
  INHALANT_PRESSURIZED: 'Inhalant (pressure)',
  POWDER: 'Powder'
} as const;

export type ProductFormulation = (typeof ProductFormulations)[keyof typeof ProductFormulations];

interface FormulationIconDefn {
  icon: typeof SvgIcon;
  color: string;
  displayName: string;
}

export const ProductFormulationsMap: Record<ProductFormulation, FormulationIconDefn> = {
  [ProductFormulations.HERB_DRIED]: {
    icon: MgCannabis,
    color: '#4F6B73',
    displayName: 'Flower'
  },
  [ProductFormulations.INHALATION]: {
    icon: MgCartridge,
    color: '#23AFFF',
    displayName: 'Inhalation'
  },
  [ProductFormulations.CAPSULE]: {
    icon: MgCapsule,
    color: '#EC407A',
    displayName: 'Capsule'
  },
  [ProductFormulations.ORAL_LIQUID]: {
    icon: MgOralLiquid,
    color: '#7986CB',
    displayName: 'Oral liquid'
  },
  [ProductFormulations.PASTILLE]: {
    icon: MgPastille,
    color: '#FFA726',
    displayName: 'Pastille'
  },
  [ProductFormulations.TABLET_CHEWABLE]: {
    icon: MgTablets,
    color: '#ba2cbf',
    displayName: 'Chewable tablet'
  },
  [ProductFormulations.DEVICE]: {
    icon: MgDevice,
    color: '#0074C4',
    displayName: 'Device'
  },
  [ProductFormulations.SPRAY]: {
    icon: MgSpray,
    color: '#406ac9', // todo real colour
    displayName: 'Spray'
  },
  [ProductFormulations.TOPICAL]: {
    icon: MgTopical,
    color: '#9E9D24', // todo real colour
    displayName: 'Topical'
  },
  [ProductFormulations.WAFER]: {
    icon: MgWafer,
    color: '#EF6C00', // todo real colour
    displayName: 'Wafer'
  },
  [ProductFormulations.CONCENTRATED_EXTRACT]: {
    icon: MgResin,
    color: '#4A148C',
    displayName: 'Concentrated Extract'
  },
  [ProductFormulations.INHALANT_PRESSURIZED]: {
    icon: MgInhaler,
    color: '#00897B',
    displayName: 'Inhalant (pressure)'
  },
  [ProductFormulations.POWDER]: {
    icon: MgPowder,
    color: '#AF7320',
    displayName: 'Powder'
  }
} as const;
